import {
    Button,
    Card,
    ChoiceList,
    Heading,
    RadioButton,
    Select,
    Stack,
    Checkbox,
    TextStyle,
    Popover,
    ActionList,
    RangeSlider,
} from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import ColorSettings from "../../components/ColorSettings"
import GeneralSettings from "../../components/GeneralSettings"
import TextSettings from "../../components/TextSettings"
import ListAttribute from "./components/ListAttribute"
import "./styles.scss"
import Preloader from "../../components/Preloader"
import axios from "../../funcs/axios"
let clientUrl1 = "electro-5-demo.myshopify.com"
function mapStateToProps(state) {
    return {
        app_settings: state.app_settings,
        app_render: state.app_render,
        app_edited: state.app_edited,
        plan: state.plan,
        compare_custom: state.compare_custom,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class GeneralPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            app_settings: JSON.parse(JSON.stringify(props.app_render)),
            wishlist_settings_edited: JSON.parse(
                JSON.stringify(props.app_edited.wishlist_settings_edited),
            ),
            compare_settings_edited: JSON.parse(
                JSON.stringify(props.app_edited.compare_settings_edited),
            ),
            general_settings_edited: JSON.parse(
                JSON.stringify(props.app_edited.general_settings_edited),
            ),
            isReady: false,
            isLoading: false,
            openSidebar: false,
            openTemplateCustom: false,
            toast: {
                show: false,
                content: "",
                error: false,
            },
            selectedPage: "arena-wishlist-page",
            errorValidate: {
                error_1: "", // wishlist add class error
                error_2: "", // wishlist show class error
                error_2a: "", // wishlist remove class error
                error_3: "", // compare add class error
                error_4: "", // compare show class error
                error_4a: "", // compare remove class error
            },
            options: [],
            active: false,
            appWaiting: false,

            // attribute to compare
            compare_custom: { ...this.props.compare_custom },
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.compare_custom !== prevState.compare_custom) {
            let compareCustom = nextProps.compare_custom.attribute_compare
            const { app_settings } = prevState
            const { compare_settings } = app_settings
            let compareOptions = [...compare_settings.compare_options2]
            if (compareCustom.length) {
                const result = compareOptions.map((item) => {
                    const coll = item.key
                    const data = item.data
                    const Compare = compareCustom.filter((item1) => item1.key === coll)
                    console.log(Compare)
                    if (Compare.length === 0) return null
                    const result1 = data.filter((x) => Compare[0].data.includes(x))
                    return {
                        key: coll,
                        data: [...result1],
                    }
                })
                const checkNull = result.filter((item) => item !== null)
                compare_settings.compare_options2 = checkNull
            }
            return { app_settings }
        } else return null
    }

    /** Change general setting **/
    changeGeneralSettings(updateObj: Object) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                general_settings: {
                    ...this.state.app_settings.general_settings,
                    ...updateObj,
                },
            },
        })
        this.cacheSetting("general", updateObj)
    }

    toggleActive = () => {
        this.setState({ active: !this.state.active })
    }

    /**
     * Cache edited setting
     */
    cacheSetting(type: String, editObj: Object) {
        const settingKey =
            type === "wishlist"
                ? "wishlist_settings"
                : type === "compare"
                ? "compare_settings"
                : "general_settings"
        const editObjKey = Object.keys(editObj)[0]
        const editObjVal = Object.values(editObj)[0]
        const { app_settings, actions } = this.props
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            this.state
        const handleList =
            type === "wishlist"
                ? wishlist_settings_edited
                : type === "compare"
                ? compare_settings_edited
                : general_settings_edited
        const handleKey =
            type === "wishlist"
                ? "wishlist_settings_edited"
                : type === "compare"
                ? "compare_settings_edited"
                : "general_settings_edited"
        const propObjVal = app_settings[settingKey][editObjKey]
        let compareFlag = false
        if (!Array.isArray(editObjVal)) {
            // Normal value
            if (typeof editObjVal !== "object") {
                if (editObjVal === propObjVal) {
                    compareFlag = true
                }
            }
            // Object value
            else {
                if (
                    JSON.stringify({
                        ...this.state.app_settings[settingKey][editObjKey],
                        ...editObjVal,
                    }) === JSON.stringify(propObjVal)
                ) {
                    compareFlag = true
                }
            }
        } else {
            editObjVal.sort()
            propObjVal.sort()
            if (editObjVal.join() === propObjVal.join()) {
                compareFlag = true
            }
        }

        let newList = []
        let checkItemExisted = handleList.findIndex((item) => {
            let itemKey = Object.keys(item)[0]
            return itemKey === editObjKey
        })

        if (!compareFlag) {
            if (checkItemExisted !== -1) {
                newList = handleList.map((item) => {
                    let itemKey = Object.keys(item)[0]
                    if (itemKey === editObjKey) {
                        if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                            return {
                                [editObjKey]: {
                                    ...this.state.app_settings[settingKey][editObjKey],
                                    ...editObjVal,
                                },
                            }
                        } else {
                            return editObj
                        }
                    } else {
                        return item
                    }
                })
            } else {
                if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                    newList = handleList.concat([
                        {
                            [editObjKey]: {
                                ...this.state.app_settings[settingKey][editObjKey],
                                ...editObjVal,
                            },
                        },
                    ])
                } else {
                    newList = handleList.concat([editObj])
                }
            }
        } else {
            newList = handleList.filter((item) => {
                let itemKey = Object.keys(item)[0]
                return itemKey !== editObjKey
            })
        }

        this.setState({
            [handleKey]: newList,
        })
        actions.changeAppEditedAction(handleKey, newList)
        this.changeSetting()
    }

    changeSetting() {
        const { actions } = this.props
        setTimeout(() => {
            actions.changeAppRenderAction("general", this.state.app_settings.general_settings)
            actions.changeAppRenderAction("wishlist", this.state.app_settings.wishlist_settings)
            actions.changeAppRenderAction("compare", this.state.app_settings.compare_settings)
        })
    }

    appProxyChange(val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                wishlist_settings: {
                    ...this.state.app_settings.wishlist_settings,
                    wishlist_layout: val,
                },
            },
        })
        // Cache edited setting
        this.cacheSetting("wishlist", { wishlist_layout: val })
    }

    /**
     * Change options setting function
     */
    optionSettings(val: Array<String>, name: String, type: String) {
        if (type === "compare") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_options: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_options: val })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_options: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { wishlist_options: val })
        }
    }

    /**
     * Change icon settings
     */
    updateIconSettings(setting_type: String, icon_type: String, updateObj: Object) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                [setting_type]: {
                    ...this.state.app_settings[setting_type],
                    [icon_type]: {
                        ...this.state.app_settings[setting_type][icon_type],
                        ...updateObj,
                    },
                },
            },
        })

        this.cacheSetting(setting_type.replace("_settings", ""), {
            [icon_type]: {
                ...this.state.app_settings[setting_type][icon_type],
                ...updateObj,
            },
        })
    }

    /* Change color pop up add multi  */
    handleMultiSetting(val, type) {
        const { app_settings } = this.state
        let newWidget = Object.assign({}, app_settings)
        const { add_multiple_settings } = newWidget.wishlist_settings
        add_multiple_settings[type] = val
        this.setState({ app_settings: newWidget })
        this.cacheSetting("wishlist", {
            add_multiple_settings: { ...add_multiple_settings },
        })
    }

    handleChangeColorPage(val, page, type) {
        const { app_settings } = this.state
        let newWidget = Object.assign({}, app_settings)
        if (page == "wishlist") {
            switch (type) {
                case "background_color":
                    newWidget.wishlist_settings[type] = val
                    break
                case "text_color":
                    newWidget.wishlist_settings.text_color = val
                    break
                default:
                    break
            }
        } else {
            switch (type) {
                case "background_color":
                    newWidget.compare_settings.background_color = val
                    break
                case "text_color":
                    newWidget.compare_settings.text_color = val
                    break
                default:
                    break
            }
        }
        this.setState({ app_settings: newWidget })
        this.cacheSetting(page, {
            [type]: val,
        })
    }

    handleChangePage(key, val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                general_settings: {
                    ...this.state.app_settings.general_settings,
                    [key]: val,
                },
            },
        })
        // Cache edited setting
        this.cacheSetting("general", { [key]: val })
    }

    handleChangeCustomePage(key, val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                wishlist_settings: {
                    ...this.state.app_settings.wishlist_settings,
                    [key]: val,
                },
            },
        })
        // Cache edited setting
        this.cacheSetting("wishlist", { [key]: val })
    }

    handleChangeMultipleProduct() {
        if (this.props.plan.plan != "free") {
            const { app_settings } = this.state
            let newWidget = Object.assign({}, app_settings)
            newWidget.wishlist_settings.allow_multiple = !newWidget.wishlist_settings.allow_multiple
            this.setState({ app_settings: newWidget })
            this.cacheSetting("wishlist", {
                allow_multiple: newWidget.wishlist_settings.allow_multiple,
            })
        }
    }

    handleShowLayout(val) {
        if (val) {
            this.appProxyChange("canvas")
        } else {
            this.appProxyChange("page")
        }
    }

    handleShowLayoutCompare(val) {
        if (val) {
            this.handleChangeCustomeCompare("compare_layout", "popup")
        } else {
            this.handleChangeCustomeCompare("compare_layout", "page")
        }
    }

    handleShowAttributesCompare(val) {
        if (val) {
            this.handleChangeCustomeCompare("custom_compare", true)
        } else {
            this.handleChangeCustomeCompare("custom_compare", false)
        }
    }

    handleChangeCustomeCompare(key, val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                compare_settings: {
                    ...this.state.app_settings.compare_settings,
                    [key]: val,
                },
            },
        })
        // Cache edited setting
        this.cacheSetting("compare", { [key]: val })
    }

    handleRedirectAddToCart(val) {
        if (val) {
            this.handleChangeCustomePage("redirect_wishlist", "products")
        } else this.handleChangeCustomePage("redirect_wishlist", "cart")
    }

    // Export
    exportToJsonFile(jsonData) {
        let dataStr = JSON.stringify(jsonData)
        let dataUri = "data:application/json;charset=utf-8," + encodeURIComponent(dataStr)

        let exportFileDefaultName = "data.json"

        let linkElement = document.createElement("a")
        linkElement.setAttribute("href", dataUri)
        linkElement.setAttribute("download", exportFileDefaultName)
        linkElement.click()
    }
    /**
     * Save Settings Func
     */
    saveSettingsCustome(data, checkImport) {
        const { actions } = this.props
        // Set loading and disable save button
        this.setState({
            appWaiting: true,
        })
        if (checkImport) {
            this.setState({ settingLoading: true })
        }
        this.setState({ app_settings: JSON.parse(JSON.stringify(data)) })
        setTimeout(() => {
            axios
                .post(`${window.SHOPIFY_APP_HOST}/admin/save-app-settings`, this.state.app_settings)
                .then((response) => {
                    const resObj = response.data
                    if (resObj.status === "success") {
                    } else {
                        throw new Error(resObj.msg)
                    }

                    axios
                        .post(
                            `${window.SHOPIFY_APP_HOST}/admin/save-app-text-settings`,
                            this.state.app_settings.general_settings,
                        )
                        .then((response) => {
                            const resObj = response.data
                            if (resObj.status === "success") {
                                actions.AppNotify({
                                    content: resObj.msg,
                                    show: true,
                                    error: false,
                                })
                            } else {
                                throw new Error(resObj.msg)
                            }
                        })
                        .catch((err) => {
                            actions.AppNotify({
                                content: `${err.message}. Please try again.`,
                                show: true,
                                error: true,
                            })
                        })
                        .finally(() => {
                            window.location.reload()
                        })
                })
                .catch((err) => {
                    actions.AppNotify({
                        content: `${err.message}. Please try again.`,
                        show: true,
                        error: true,
                    })
                })
        }, 0)
    }

    /**
     * Change Product Amount setting function
     */
    productNumberSettings(val: Number, type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_product_number: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { wishlist_product_number: val })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_product_number: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_product_number: val })
        }
    }

    //Import
    loadImport(contents) {
        try {
            let setting = JSON.parse(contents)
            this.saveSettingsCustome(setting, true)
        } catch (error) {
            console.log(error)
            this.props.actions.AppNotify({
                content: `${error.message}. Please try again.`,
                show: true,
                error: true,
            })
        }
    }
    openFileDialog(accept, multy = false, callback) {
        var inputElement = document.createElement("input")
        inputElement.type = "file"
        inputElement.accept = accept // Note Edge does not support this attribute
        if (multy) {
            inputElement.multiple = multy
        }
        if (typeof callback === "function") {
            inputElement.addEventListener("change", callback)
        }
        // const inputElement = document.getElementById('file-upload');
        inputElement.dispatchEvent(new MouseEvent("click"))
    }

    // userButton click event
    openDialogClick() {
        // open file dialog for text files
        this.openFileDialog(".json", true, this.fileDialogChanged.bind(this))
    }

    importToJsonFile() {
        // open a dialog function
        this.openDialogClick()
    }

    // file dialog onchange event handler
    fileDialogChanged2(e) {
        var file = e.target.files[0]
        if (!file) {
            return
        }
        let fd = new FormData()
        fd.append("files", file)
        axios({
            method: "post",
            url: `${window.SHOPIFY_APP_HOST}/admin/convert`,
            data: fd,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "success") {
                    // this.props.actions.AppNotify({
                    //     content: "Re-install successfully",
                    //     show: true,
                    //     error: false,
                    // })
                    // setTimeout(() => {
                    //     window.location.reload()
                    // }, 0)
                } else {
                    throw new Error(resObj.msg)
                }
            })
            .catch((err) => {
                // actions.AppNotify({
                //     content: `Re-install fail. Please try again.`,
                //     show: true,
                //     error: true,
                // })
            })
            .finally(() => {
                this.setState({
                    appWaiting: false,
                })
            })
    }

    convertToJsonFile() {
        // open a dialog function
        this.openFileDialog(".csv", true, this.fileDialogChanged2.bind(this))
    }

    handleCompareOptions(val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                compare_settings: {
                    ...this.state.app_settings.compare_settings,
                    compare_options2: val,
                },
            },
        })

        const { actions } = this.props

        actions.changeAppEditedAction("compare_settings_edited", [{ compare_options2: val }])
        this.changeSetting()
    }

    // file dialog onchange event handler
    fileDialogChanged(e) {
        var file = e.target.files[0]
        if (!file) {
            return
        }
        var reader = new FileReader()
        var contents = ""
        reader.onload = (e) => {
            contents = e.target.result
            this.loadImport(contents)
        }
        reader.readAsText(file)
    }

    render() {
        let action_btn = ["text"]
        const { selectedPage, active, appWaiting } = this.state
        const { actions, options } = this.props
        const { wishlist_settings, compare_settings, general_settings } = this.state.app_settings
        const wl_cp_preloader_code = `<a>
    <svg width="12" height="12" class="arn_icon arn_icon-preloader"><use xlink:href="#arn_icon-preloader"></use></svg>
</a>`
        const pageWishListMode = [
            { label: "List and Grid", value: "both" },
            { label: "List", value: "list" },
            { label: "Grid", value: "grid" },
        ]

        const notificationLocation = [
            { label: "Top Left", value: "top-left" },
            { label: "Top Right", value: "top-right" },
            { label: "Bottom Left", value: "bottom-left" },
            { label: "Bottom Right", value: "bottom-right" },
        ]

        const activator = (
            <Button disclosure onClick={() => this.toggleActive()}>
                Backup Settings
            </Button>
        )

        let ImportTabs = {
            content: "Import",
            onAction: () => this.importToJsonFile(),
        }

        let ExportTabs = {
            content: "Export",
            onAction: () => this.exportToJsonFile(this.state.app_settings),
        }
        return (
            <div className="yta-widgets-management">
                <div className="widgets-management-body">
                    <div className="title-block">
                        <Stack distribution="equalSpacing" alignment="center">
                            <Stack.Item fill>
                                <Stack
                                    alignment="center"
                                    spacing="extraLoose"
                                    distribution="equalSpacing"
                                >
                                    <div className="page-title">General Settings</div>
                                    <Popover
                                        active={active}
                                        activator={activator}
                                        onClose={() => this.toggleActive()}
                                    >
                                        <ActionList items={[ExportTabs, ImportTabs]} />
                                    </Popover>
                                </Stack>
                            </Stack.Item>
                        </Stack>
                    </div>
                    {appWaiting ? <Preloader /> : null}
                    <div className="subtitle-block">
                        <div className="page-text">
                          These settings will be used for both the Wishlist and Compare.
                        </div>
                    </div>

                    <div className="yta-support">
                        <div className="yta-support-body">
                            <GeneralSettings
                                app_settings={this.state.app_settings}
                                previewCode={wl_cp_preloader_code}
                                settings={general_settings}
                                changeGeneralSettings={this.changeGeneralSettings.bind(this)}
                                updateIcon={this.updateIconSettings.bind(this)}
                            />

                            <div className="standard mt-50">
                                <div className="standard-left">
                                    <Stack vertical className="standard-left">
                                        <TextStyle variation="strong">Wishlist Settings</TextStyle>
                                        <TextStyle variation="subdued">
                                          Standard settings are used to manage some options that are available for the Wishlist Feature
                                        </TextStyle>
                                    </Stack>
                                </div>
                                <div className="standard-right">
                                    <Stack vertical>
                                        <Card>
                                            <Card.Section>
                                                <Heading>
                                                  The number of products that can be added to the Wishlist
                                                </Heading>
                                                <RangeSlider
                                                    value={
                                                        this.props.plan.plan != "free"
                                                            ? 9999
                                                            : wishlist_settings &&
                                                              wishlist_settings.wishlist_product_number
                                                    }
                                                    disabled={this.props.plan.plan != "free"}
                                                    min={2}
                                                    max={
                                                        window.parentUrl === clientUrl1
                                                            ? 100
                                                            : this.props.plan.plan != "free"
                                                            ? 9999
                                                            : 20
                                                    }
                                                    onChange={(val) => {
                                                        this.productNumberSettings(val, "wishlist")
                                                    }}
                                                    output
                                                    suffix={
                                                        <p>
                                                            {this.props.plan.plan != "free"
                                                                ? 9999
                                                                : wishlist_settings &&
                                                                  wishlist_settings.wishlist_product_number}
                                                        </p>
                                                    }
                                                />
                                            </Card.Section>
                                            {wishlist_settings &&
                                            wishlist_settings.allow_multiple ? (
                                                <Card.Section>
                                                    <Stack vertical>
                                                        <Heading>
                                                            Multi-wishlist popup settings
                                                        </Heading>
                                                        <Heading>Button Add Setting</Heading>
                                                        <div className="row-item-wh">
                                                            <ColorSettings
                                                                general={true}
                                                                text="Background color button Add"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .add_background_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "add_background_color",
                                                                    )
                                                                }
                                                            />
                                                            <ColorSettings
                                                                general={true}
                                                                text="Border Color Button Add"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .add_border_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "add_border_color",
                                                                    )
                                                                }
                                                            />
                                                            <ColorSettings
                                                                general={true}
                                                                text="Text Color Button Add"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .add_text_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "add_text_color",
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <Heading>Button Create Setting</Heading>
                                                        <div className="row-item-wh">
                                                            <ColorSettings
                                                                general={true}
                                                                text="Background Color Button Create"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .create_background_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "create_background_color",
                                                                    )
                                                                }
                                                            />
                                                            <ColorSettings
                                                                general={true}
                                                                text="Border Color Button Create"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .create_border_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "create_border_color",
                                                                    )
                                                                }
                                                            />
                                                            <ColorSettings
                                                                general={true}
                                                                text="Text Color Button Create"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .create_text_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "create_text_color",
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <Heading>Radio Button Settings</Heading>
                                                        <div className="row-item-wh">
                                                            <ColorSettings
                                                                general={true}
                                                                text="Background color radio button"
                                                                color={
                                                                    wishlist_settings &&
                                                                    wishlist_settings.add_multiple_settings &&
                                                                    wishlist_settings
                                                                        .add_multiple_settings
                                                                        .radio_button_background_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleMultiSetting(
                                                                        val,
                                                                        "radio_button_background_color",
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </Stack>
                                                </Card.Section>
                                            ) : (
                                                ""
                                            )}
                                            <Card.Section>
                                                <Checkbox
                                                    onChange={(val) => this.handleShowLayout(val)}
                                                    checked={
                                                        wishlist_settings &&
                                                        wishlist_settings.wishlist_layout ==
                                                            "canvas"
                                                            ? true
                                                            : false
                                                    }
                                                    label="Enable Sidebar / Drawer Mode"
                                                    helpText="This option will show you a sidebar drawer instead of the Wishlist page"
                                                />
                                            </Card.Section>
                                            <Card.Section>
                                                <Checkbox
                                                    onChange={(val) => {
                                                        this.handleRedirectAddToCart(val)
                                                    }}
                                                    checked={
                                                        wishlist_settings &&
                                                        wishlist_settings.redirect_wishlist ==
                                                            "products"
                                                            ? true
                                                            : false
                                                    }
                                                    label="Enable Redirect Button Add to cart to Product page"
                                                    helpText='A customer will see "Product page" instead of "Add to Cart"'
                                                />
                                            </Card.Section>
                                            <Card.Section>
                                                <Checkbox
                                                    onChange={(val) =>
                                                        this.handleChangeCustomePage(
                                                            "remove_add_to_cart",
                                                            val,
                                                        )
                                                    }
                                                    checked={
                                                        wishlist_settings &&
                                                        wishlist_settings.remove_add_to_cart
                                                    }
                                                    label="Enable Remove Wishlist item When Add to cart"
                                                    helpText="This option will remove Wishlist item when Add to cart"
                                                />
                                            </Card.Section>
                                            <Card.Section>
                                                <Stack vertical>
                                                    {wishlist_settings &&
                                                        wishlist_settings.wishlist_layout ==
                                                            "page" && (
                                                            <Stack vertical>
                                                                <Select
                                                                    label={
                                                                        <div>
                                                                            <span>
                                                                                Wislist Pages
                                                                            </span>
                                                                            <span className="note-page">
                                                                                must have the
                                                                                Template suffix:
                                                                                page.arn_content_wishlist
                                                                            </span>
                                                                        </div>
                                                                    }
                                                                    options={options}
                                                                    onChange={(val) =>
                                                                        this.handleChangePage(
                                                                            "wishlist_page",
                                                                            val,
                                                                        )
                                                                    }
                                                                    value={
                                                                        general_settings.wishlist_page
                                                                    }
                                                                />
                                                                <Heading>Add To Cart Style</Heading>
                                                                <ChoiceList
                                                                    choices={[
                                                                        {
                                                                            label: "Text",
                                                                            value: "text",
                                                                        },
                                                                        {
                                                                            label: "Icon",
                                                                            value: "icon",
                                                                        },
                                                                    ]}
                                                                    selected={
                                                                        (wishlist_settings &&
                                                                            wishlist_settings.wishlist_page_action) ||
                                                                        action_btn
                                                                    }
                                                                    onChange={(val, name) => {
                                                                        this.handleChangeCustomePage(
                                                                            "wishlist_page_action",
                                                                            val,
                                                                        )
                                                                    }}
                                                                />
                                                                <Heading>
                                                                    Select product attribute to
                                                                    wishlist
                                                                </Heading>
                                                                <ChoiceList
                                                                    allowMultiple
                                                                    choices={[
                                                                        {
                                                                            label: "Price",
                                                                            value: "price",
                                                                        },
                                                                        {
                                                                            label: "Available",
                                                                            value: "available",
                                                                        },
                                                                        {
                                                                            label: "Quantity",
                                                                            value: "quantity",
                                                                        },
                                                                        {
                                                                            label: "Variants",
                                                                            value: "variants",
                                                                        },
                                                                    ]}
                                                                    selected={
                                                                        (wishlist_settings &&
                                                                            wishlist_settings.wishlist_options) ||
                                                                        []
                                                                    }
                                                                    onChange={(val, name) => {
                                                                        this.optionSettings(
                                                                            val,
                                                                            name,
                                                                            "wishlist",
                                                                        )
                                                                    }}
                                                                />
                                                                <div className="pickers-color-general">
                                                                    <Heading>
                                                                        Change color page Wishlist -
                                                                        Share
                                                                    </Heading>
                                                                    <div className="row-item-wh">
                                                                        <ColorSettings
                                                                            general={true}
                                                                            text="Background page header bar"
                                                                            color={
                                                                                wishlist_settings &&
                                                                                wishlist_settings.background_color
                                                                            }
                                                                            changeColor={(val) =>
                                                                                this.handleChangeColorPage(
                                                                                    val,
                                                                                    "wishlist",
                                                                                    "background_color",
                                                                                )
                                                                            }
                                                                        />
                                                                        <ColorSettings
                                                                            general={true}
                                                                            text="Page text color"
                                                                            color={
                                                                                wishlist_settings &&
                                                                                wishlist_settings.text_color
                                                                            }
                                                                            changeColor={(val) =>
                                                                                this.handleChangeColorPage(
                                                                                    val,
                                                                                    "wishlist",
                                                                                    "text_color",
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <Select
                                                                        label={
                                                                            <div>
                                                                                <span>
                                                                                    Show list
                                                                                    wishlist mode
                                                                                </span>
                                                                            </div>
                                                                        }
                                                                        options={pageWishListMode}
                                                                        onChange={(val) =>
                                                                            this.handleChangeCustomePage(
                                                                                "page_show_mode",
                                                                                val,
                                                                            )
                                                                        }
                                                                        value={
                                                                            wishlist_settings.page_show_mode
                                                                        }
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <Heading>
                                                                      Notification when an item is added to the Wishlist
                                                                    </Heading>
                                                                    <Select
                                                                        label={
                                                                            <div>
                                                                                <span>
                                                                                    Notification
                                                                                    location
                                                                                </span>
                                                                            </div>
                                                                        }
                                                                        options={
                                                                            notificationLocation
                                                                        }
                                                                        onChange={(val) =>
                                                                            this.handleChangeCustomePage(
                                                                                "added_wl_notifications",
                                                                                val,
                                                                            )
                                                                        }
                                                                        value={
                                                                            wishlist_settings.added_wl_notifications
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className="pickers-color-general">
                                                                    <div className="row-item-wh">
                                                                        <ColorSettings
                                                                            general={true}
                                                                            text="Background color"
                                                                            color={
                                                                                wishlist_settings &&
                                                                                wishlist_settings.added_wl_notifications_bg
                                                                            }
                                                                            changeColor={(val) =>
                                                                                this.handleChangeCustomePage(
                                                                                    "added_wl_notifications_bg",
                                                                                    val,
                                                                                )
                                                                            }
                                                                        />
                                                                        <ColorSettings
                                                                            general={true}
                                                                            text="Text color"
                                                                            color={
                                                                                wishlist_settings &&
                                                                                wishlist_settings.added_wl_notifications_color
                                                                            }
                                                                            changeColor={(val) =>
                                                                                this.handleChangeCustomePage(
                                                                                    "added_wl_notifications_color",
                                                                                    val,
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </Stack>
                                                        )}

                                                    <Stack vertical>
                                                        <Select
                                                            label={
                                                                <div>
                                                                    <span>Share Pages</span>
                                                                    <span className="note-page">
                                                                        must have the Template
                                                                        suffix:
                                                                        page.arn_share_wishlist
                                                                    </span>
                                                                </div>
                                                            }
                                                            options={options}
                                                            onChange={(val) =>
                                                                this.handleChangePage(
                                                                    "share_page",
                                                                    val,
                                                                )
                                                            }
                                                            value={general_settings.share_page}
                                                        />
                                                    </Stack>
                                                </Stack>
                                            </Card.Section>
                                        </Card>
                                    </Stack>
                                </div>
                            </div>

                            <div className="standard mt-50">
                                <div className="standard-left">
                                    <Stack vertical className="standard-left">
                                        <TextStyle variation="strong">Compare Settings</TextStyle>
                                        <TextStyle variation="subdued">
                                          Standard settings are used to manage some options that are available for Compare Feature
                                        </TextStyle>
                                    </Stack>
                                </div>
                                <div className="standard-right">
                                    <Stack vertical>
                                        <Card>
                                            <Card.Section>
                                                <Heading>
                                                  The number of products that can be added to the Compare list
                                                </Heading>
                                                <RangeSlider
                                                    value={compare_settings.compare_product_number}
                                                    min={2}
                                                    max={4}
                                                    onChange={(val) => {
                                                        this.productNumberSettings(val, "compare")
                                                    }}
                                                    output
                                                    suffix={
                                                        <p>
                                                            {
                                                                compare_settings.compare_product_number
                                                            }
                                                        </p>
                                                    }
                                                />
                                            </Card.Section>
                                            <Card.Section>
                                                <Checkbox
                                                    onChange={(val) =>
                                                        this.handleShowLayoutCompare(val)
                                                    }
                                                    checked={
                                                        compare_settings.compare_layout == "popup"
                                                            ? true
                                                            : false
                                                    }
                                                    label="Enable Popup Mode"
                                                    helpText="This option will show you a popup instead of the Compare Page"
                                                />
                                            </Card.Section>
                                            <Card.Section>
                                                <Stack vertical>
                                                    {compare_settings.compare_layout == "page" && (
                                                        <Stack vertical>
                                                            <Select
                                                                label={
                                                                    <div>
                                                                        <span>Compare Pages</span>
                                                                        <span className="note-page">
                                                                            must have the Template
                                                                            suffix: page.arn_compare
                                                                        </span>
                                                                    </div>
                                                                }
                                                                options={options}
                                                                onChange={(val) =>
                                                                    this.handleChangePage(
                                                                        "compare_page",
                                                                        val,
                                                                    )
                                                                }
                                                                value={
                                                                    general_settings.compare_page
                                                                }
                                                            />
                                                        </Stack>
                                                    )}
                                                    <Heading>
                                                        Select product attribute to compare
                                                    </Heading>
                                                    <ChoiceList
                                                        allowMultiple
                                                        choices={[
                                                            {
                                                                label: "Availability",
                                                                value: "availability",
                                                            },
                                                            {
                                                                label: "Options",
                                                                value: "options",
                                                            },
                                                            {
                                                                label: "Vendor",
                                                                value: "vendor",
                                                            },
                                                            {
                                                                label: "Collection",
                                                                value: "collection",
                                                            },
                                                        ]}
                                                        selected={compare_settings.compare_options}
                                                        onChange={(val, name) => {
                                                            this.optionSettings(
                                                                val,
                                                                name,
                                                                "compare",
                                                            )
                                                        }}
                                                    />
                                                    {/* {window.parentUrl === clientUrl1 ? (
                                                        <Checkbox
                                                            onChange={(val) =>
                                                                this.handleShowAttributesCompare(
                                                                    val,
                                                                )
                                                            }
                                                            checked={
                                                                compare_settings.custom_compare
                                                                    ? true
                                                                    : false
                                                            }
                                                            label="Enable Custom Attibute Mode"
                                                            helpText="This option will show your Custom Attibute Mode of Compare Page"
                                                        />
                                                    ) : (
                                                        ""
                                                    )} */}

                                                    {compare_settings.custom_compare ? (
                                                        <ListAttribute
                                                            attribute_compare={
                                                                this.props.compare_custom
                                                                    .attribute_compare
                                                            }
                                                            compare_options={
                                                                compare_settings.compare_options2
                                                            }
                                                            changeCompareOptions={(data) =>
                                                                this.handleCompareOptions(data)
                                                            }
                                                        />
                                                    ) : (
                                                        ""
                                                    )}

                                                    <div className="pickers-color-general">
                                                        <Heading>Change color page Compare</Heading>
                                                        <div className="row-item-wh">
                                                            <ColorSettings
                                                                general={true}
                                                                text="Background page header bar"
                                                                color={
                                                                    compare_settings.background_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleChangeColorPage(
                                                                        val,
                                                                        "compare",
                                                                        "background_color",
                                                                    )
                                                                }
                                                            />
                                                            <ColorSettings
                                                                general={true}
                                                                text="Page text color"
                                                                color={compare_settings.text_color}
                                                                changeColor={(val) =>
                                                                    this.handleChangeColorPage(
                                                                        val,
                                                                        "compare",
                                                                        "text_color",
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Heading>
                                                          Notification when an item is added to the Compare list
                                                        </Heading>
                                                        <Select
                                                            label={
                                                                <div>
                                                                    <span>
                                                                        Notification location
                                                                    </span>
                                                                </div>
                                                            }
                                                            options={notificationLocation}
                                                            onChange={(val) =>
                                                                this.handleChangeCustomeCompare(
                                                                    "added_cp_notifications",
                                                                    val,
                                                                )
                                                            }
                                                            value={
                                                                compare_settings.added_cp_notifications
                                                            }
                                                        />
                                                    </div>

                                                    <div className="pickers-color-general">
                                                        <div className="row-item-wh">
                                                            <ColorSettings
                                                                general={true}
                                                                text="Background color"
                                                                color={
                                                                    compare_settings &&
                                                                    compare_settings.added_cp_notifications_bg
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleChangeCustomeCompare(
                                                                        "added_cp_notifications_bg",
                                                                        val,
                                                                    )
                                                                }
                                                            />
                                                            <ColorSettings
                                                                general={true}
                                                                text="Text color"
                                                                color={
                                                                    compare_settings &&
                                                                    compare_settings.added_cp_notifications_color
                                                                }
                                                                changeColor={(val) =>
                                                                    this.handleChangeCustomeCompare(
                                                                        "added_cp_notifications_color",
                                                                        val,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </Stack>
                                            </Card.Section>
                                        </Card>
                                    </Stack>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralPage)
